<template>
    <div id="preview">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">作业预览</p>
        </div>
        <div v-if="loading">
            <div class="nowork"
                 v-if="question && !question.length">
                <span class="icon-meiyoufabushijuan"></span>
                <p>没有作业数据</p>
            </div>
            <template v-else>
                <div class="wrap"
                     v-if="type==4">
                    <div class="total">
                        <div>共{{number}}题</div>
                    </div>
                    <div class="question">
                        <div class="sx"
                             v-for="(data,index) in question">
                            <div class="sx-tit">{{ data.name }}</div>
                            <div class="sx-stem"
                                 v-for="list in data.list">
                                <span class="stem">{{list.subject}}&nbsp;(</span><span class="stem-answer">{{list.answer}}</span>)
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wrap"
                     v-else>
                    <div class="total"
                         v-if="type != '2022winternew'&&type != '2023winternew'&&type != '2024winternew'">
                        <div>共{{number}}题</div>
                    </div>
                    <div class="winter2022-video-list"
                         v-if="type == '2022winternew'||type == '2023winternew'||type == '2024winternew'">
                        <div class="winter2022-video-item"
                             v-for="(item,index) in k_list"
                             @click="playVideo(item)"
                             :key="index">
                            <span class="icon-play"></span>
                            <p>{{item.k_name}}</p>
                        </div>
                    </div>
                    <div class="question">
                        <div class="exercises"
                             v-for="(data,index) in question">
                            <div class="quest_title"
                                 v-if="data.asks.length>1">
                                <div v-if="data.subject.content||data.subject.image">
                                    <p>
                                        <!-- <span class="tit_num" v-if="data.number">{{data.number}}、</span> -->
                                        <span v-if="data.subject.content!=''"
                                              v-html='data.subject.content'></span>
                                    </p>
                                    <img :src="data.subject.image"
                                         v-if="data.subject.image!=''">
                                </div>
                            </div>
                            <!-- 小学 -->
                            <div v-if='sid == 21'>
                                <div v-for="ask,inx in data.asks">
                                    <!-- 选择题 -->
                                    <div class="choose"
                                         v-if="ask.display_type==1">
                                        <choice :question='ask'
                                                :askLength='data.asks.length'></choice>
                                    </div>
                                    <!-- 填空 -->
                                    <div v-if='ask.display_type == 2'>
                                        <blanks :question='ask'
                                                :askLength='data.asks.length'></blanks>
                                    </div>
                                    <!-- 主观题 -->
                                    <div v-if='ask.display_type == 3'>
                                        <subjective :ask='data.asks'
                                                    :index='inx'
                                                    :question='ask'
                                                    :askLength='data.asks.length'></subjective>
                                    </div>
                                    <!-- 连线题 -->
                                    <div class="line"
                                         v-if="ask.display_type==4">
                                        <!-- <line :ask='ask' :sheet="a.right_answer" :result="a.user_result" :onlyshow='true' :tag='1'></line> -->
                                        <lines :ask='ask'
                                               :sheet="ask.right_answer"
                                               :onlyshow='false'
                                               :askLength='data.asks.length'></lines>
                                    </div>
                                </div>
                            </div>
                            <!-- 初中 -->
                            <div v-else>
                                <div v-for="ask,inx in data.asks">
                                    <!-- 选择题 -->
                                    <div class="choose"
                                         v-if="data.display==1">
                                        <choice :question='ask'
                                                :askLength='data.asks.length'></choice>
                                    </div>
                                    <!-- 填空 -->
                                    <div v-if='data.display == 2'>
                                        <blanks :question='ask'
                                                :askLength='data.asks.length'></blanks>
                                    </div>
                                    <!-- 主观题 -->
                                    <div v-if='data.display == 3'>
                                        <subjective :ask='data.asks'
                                                    :index='inx'
                                                    :question='ask'
                                                    :askLength='data.asks.length'></subjective>
                                    </div>
                                    <!-- 连线题 -->
                                    <div class="line"
                                         v-if="data.display == 4">
                                        <!-- <line :ask='ask' :sheet="a.right_answer" :result="a.user_result" :onlyshow='true' :tag='1'></line> -->
                                        <lines :ask='ask'
                                               :sheet="ask.right_answer"
                                               :onlyshow='false'
                                               :askLength='data.asks.length'></lines>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <videoPlayer v-if="!inApp"
                             ref="videoPlayer"
                             @closePlayer="closePlayer"
                             v-show="playFlag"
                             :video_url="video_url"
                             submit="1"></videoPlayer>
            </template>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/tealoading.vue';
import choice from 'VIEWS/math/module/choice.vue'  //选择题
import blanks from 'VIEWS/math/module/blanks.vue'  //填空题
import lines from 'VIEWS/math/module/line.vue';     //连线题
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗
export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            loading: false,
            question: [],
            type: this.$route.params.type,
            taskId: this.$route.params.taskid,
            sid: this.$route.params.sid,		//学科sid
            hd_type: this.$route.query.hd_type,		//活动id
            number: null,
            k_list: [],//2022寒假数学新课预习视频
            playFlag: false,
            video_url: '',
        }
    },
    methods: {
        /**退出视频 */
        closePlayer () {
            this.playFlag = false;
        },
        back () {
            this.$router.go(-1)
        },
        preview () {
            let type = this.type;
            if (type == 4) {
                this.$http.post(API_URL_TASK_API + '/maths/check/quick/preview', {
                    "message_id": this.taskId,
                }).then(res => {
                    this.loading = true;
                    if (res.data.response == 'ok') {
                        this.question = res.data.data;
                        let num = 0;
                        this.question.forEach(d => {
                            num = num + d.list.length
                        });
                        this.number = num
                    }
                })
            } else {
                let url = "", data = {};
                if (this.type == "qz") {
                    url = API_URL_HD_API + '/qz2022/tea/question_preview';
                    data = { "paper_id": this.taskId, "sid": 21 }

                } else if (this.type == '2022winter') {
                    url = API_URL_HD_API + '/winter2022/tea/question_preview';
                    data = { "paper_id": this.taskId, "sid": 21 }
                } else if (this.type == '2022winternew') {
                    url = API_URL_HD_API + '/winter2022/stu/preview/';
                    data = { "paper_id": this.taskId, "sid": 21 }
                }
                else if (this.type == "qm") {
                    url = API_URL_HD_API + '/qm2022_down/tea/question_preview';
                    data = { "paper_id": this.taskId, "sid": 21 }
                }
                else if (this.type == "2023kxjc") {
                    url = API_URL_HD_API + '/kxjc2023/tea/question_preview';
                    data = { "paper_id": this.taskId, "sid": 21 }
                }
                else if (this.type == "2023jdjc") {
                    url = API_URL_HD_API + '/common/tea/question_preview';
                    data = { "paper_id": this.taskId, "sid": 21, "hd_type": 5 }
                }
                else if (this.hd_type) {
                    url = API_URL_HD_API + '/common/tea/question_preview';
                    data = { "paper_id": this.taskId, "sid": 21, "hd_type": this.hd_type }
                }
                else if (this.type == '2023winter' || this.type == '2024winter') {
                    url = API_URL_HD_API + '/winter2023/tea/question_preview';
                    data = { "paper_id": this.taskId, "sid": 21 }
                } else if (this.type == '2023winternew' || this.type == '2024winternew') {
                    url = API_URL_HD_API + '/winter2023/stu/preview/';
                    data = { "paper_id": this.taskId, "sid": 21 }
                }
                else {
                    url = API_URL_TASK_API + '/maths/check/task/preview';
                    data = { "message_id": this.taskId, "sid": this.sid }
                }
                this.$http.post(url, data).then(res => {
                    this.loading = true;
                    if (res.data.response == 'ok') {
                        this.question = res.data.data;
                        if (this.type == '2022winternew' || this.type == '2023winternew' || this.type == '2024winternew') {
                            this.k_list = res.data.data.k_list;
                            this.question = res.data.data.questions;
                        }
                        let num = 0;
                        this.question.forEach(d => {
                            num = num + d.asks.length
                        });
                        this.number = num
                    }
                    this.$nextTick(function () {
                        MathJax.Hub.Typeset(document.body)
                    })
                })
            }
        },
        //播放视频    2022寒假数学新课预习
        playVideo (item) {
            if (this.inApp) {
                this.appFunction("ys_video", `${item.video_url}`)
            } else {
                this.video_url = item.video_url;
                this.playFlag = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
                return
            }
        }
    },
    created () {
        this.preview()

    },
    destroyed () {
    },
    components: {
        loadingS,
        choice,
        blanks,
        lines,
        videoPlayer
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
#preview {
    padding-top: 96px / $ppr;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}

.wrap {
    .total {
        width: 100%;
        height: 2.4rem;
        line-height: 2.4rem;
        background-color: #fff;
        margin-bottom: 24px / $ppr;
        div {
            font-size: 30px / $ppr;
            font-weight: 600;
            color: #333;
            padding-left: 24px / $ppr;
        }
    }
}

.question {
    font-family: Monospace;
    .order {
        color: $c-theme;
    }
    .title {
        background-color: $c-fbg;
        border-bottom: 1px / $ppr solid #e8e8e8;
        padding: $w $w;
    }
    .img-wrap {
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        justify-content: center;
        -webkit-justify-content: center;
        img {
            display: inline-block;
        }
    }
    .ask {
        margin-bottom: $w;
        background-color: $c-fbg;
    }
    .subtitle-wrap {
        border-bottom: 1px / $ppr solid #e8e8e8;
    }
    .subtitle {
        padding: $w $w;
        vertical-align: top;
    }
    .option {
        padding: $w $w;
        border-bottom: 1px / $ppr solid #e8e8e8;
        display: flex;
        display: -webkit-flex;
        .spot {
            display: block;
            width: $w * 2;
            height: $w * 2;
            line-height: $w * 2;
            text-align: center;
            border: 1px / $ppr solid #e8e8e8;
            border-radius: $w;
            margin-right: $w;
        }
        .content {
            flex: 1;
            -webkit-flex: 1;
        }
    }
    .sx {
        //border-bottom: 1px/$ppr solid #dcdcdc;
        margin-bottom: 24px / $ppr;
        .sx-tit {
            margin-bottom: 24px / $ppr;
            padding: 0 24px / $ppr;
            color: #999;
        }
        .sx-stem {
            padding: $w $w;
            border-bottom: 1px / $ppr solid #e8e8e8;
            background-color: $c-fbg;
            display: flex;
            display: -webkit-flex;
            flex-wrap: wrap;
            -webkit-flex-wrap: wrap;
            position: relative;
        }
        .sx-stem:last-child {
            border: 0;
        }
        .stem-answer {
            //color:#66cc22;
        }
    }
}

.exercises {
    background-color: #fff;
    margin-bottom: 24px / $ppr;
}

.exercises /deep/ ul li:last-child {
    border: 0 !important;
}

.quest_title {
    padding: 25px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #e8e8e8;
    background: #fff;
}

.nowork {
    color: $c-light;
    text-align: center;
    margin-top: 400px / $ppr;
    span {
        display: inline-block;
        color: $c-litgray;
        font-size: 130px / $ppr;
        margin-bottom: 36px / $ppr;
    }
}

.checked {
    color: #66cc22 !important;
    .spot {
        background-color: #66cc22 !important;
        border: 1px / $ppr solid #66cc22 !important;
        color: #fff;
    }
}

.question .option:last-child {
    border: 0 !important;
}

.question /deep/ .choose {
    margin-top: 0 !important;
}
.winter2022-video-list {
    margin-bottom: 24px / $ppr;

    .winter2022-video-item {
        background: #fff;
        display: flex;
        align-items: center;
        padding: 24px / $ppr;
        border-top: 1px / $ppr solid #e8e8e8;
        .icon-play {
            width: 30px / $ppr;
            height: 30px / $ppr;
            background: url("./img/icon_video.png") no-repeat center;
            background-size: 100% 100%;
            margin-right: 20px / $ppr;
        }
    }
}
/deep/.round {
    vertical-align: middle !important;
}
</style>

